import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { chatgenieAPI } from 'src/config/api';
import SimpleSelect from 'src/components/SimpleSelect';
import { SelectAsyncPaginate } from '@Thread-Magic/jasmine';
import { Wrapper, Section, SectionTitle } from './ClientFilter.style';
import RadioGroup from '../RadioGroup';

const appOptions = [
  { label: 'Messenger', value: 'messenger' },
  { label: 'Slack', value: 'slack' },
  { label: 'Ms Teams', value: 'ms_teams' }
];

const getCompanyTypes = (query, page) =>
  chatgenieAPI.getCompanyTypes({ query, page, normalizer: res => res.data });

const ClientFilter = ({ filters, onChange }) => {
  const handleChange = useCallback(
    (key, value) => {
      onChange({ ...filters, [key]: value });
    },
    [filters, onChange]
  );

  return (
    <Wrapper>
      <Section>
        <SectionTitle>Company type</SectionTitle>
        <SelectAsyncPaginate
          name="companyType"
          title="companyType"
          value={filters.companyType}
          options={getCompanyTypes}
          getOptionValue={option => option.name}
          getOptionLabel={option => option.name}
          placeholder="Select"
          onChange={option => handleChange('companyType', option)}
        />
      </Section>
      <Section>
        <SectionTitle>App</SectionTitle>
        <SimpleSelect
          name="app"
          title="app"
          value={appOptions.find(option => option.value === filters.app)}
          options={appOptions}
          getOptionValue={option => option.value}
          getOptionLabel={option => option.label}
          onChange={option => handleChange('app', option.value)}
        />
      </Section>
      <Section>
        <SectionTitle>Deploy status</SectionTitle>
        <RadioGroup
          value={filters.state}
          options={[
            { label: 'Any', value: 'any' },
            { label: 'Only deployed apps', value: 'deployed' },
            { label: 'Only undeployed', value: 'not_deployed' }
          ]}
          onChange={value => handleChange('state', value)}
        />
      </Section>
    </Wrapper>
  );
};

ClientFilter.defaultProps = {
  filters: {
    state: 'any',
    app: null,
    companyType: ''
  }
};

ClientFilter.propTypes = {
  filters: PropTypes.shape({
    state: PropTypes.string,
    app: PropTypes.string,
    companyType: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })
  }),
  onChange: PropTypes.func.isRequired
};

export default ClientFilter;
